import React from 'react';
import classnames from 'classnames';
import type {ButtonProps} from '@albert-io/atomic/atoms/Button/Button.react';

import {Anchor, Icon, WithTooltip} from '@albert-io/atomic';

import GoogleContext from '../Google.context';

interface Props extends ButtonProps<'button'> {
  hideIcon?: boolean;
}

// TODO: define this type
type GoogleC = any;

const GoogleSwitchAccountsButton = ({className, hideIcon = false}: Props) => {
  const {isRequestPending, handleSignOut, loggedInUserEmail} =
    React.useContext<GoogleC>(GoogleContext);
  const hasUserEmail = !!loggedInUserEmail;
  return (
    <WithTooltip
      content={`Currently signed in as ${loggedInUserEmail}`}
      enabled={hasUserEmail}
      propagateHoverEvent
      theme='light'
      zLevel='modal'
    >
      <Anchor
        aria-label={
          loggedInUserEmail
            ? `Currently signed into Google as ${loggedInUserEmail}. Click to switch accounts.`
            : undefined
        }
        className={classnames('inline-flex', 'items-center', className)}
        disabled={isRequestPending}
        onClick={handleSignOut}
      >
        {!hideIcon && <Icon className='mr-x1' icon={['fab', 'google']} />}
        Switch accounts
      </Anchor>
    </WithTooltip>
  );
};

export default GoogleSwitchAccountsButton;
